import React, { useMemo, forwardRef } from 'react'
import cn from 'classnames'

import { ACCEPTED_DIMENSIONS } from './constants'

const withUbliqueStyle = (WrappedComponent, componentClassName) => {
  return forwardRef((props, ref) => {
    const { ubliqueStyle, ubliqueFixed, ...otherProps } = props

    const newClassname = useMemo(() => {
      let classes = []

      // This removes the not supported classnames and saves them for a warning messages
      const filterClassName = (name) => {
        if (!ACCEPTED_DIMENSIONS.includes(name)) {
          console.warn(
            `The values not in the range [sm, md, lg] will be ignored. You provided: ${name}`
          )
          return false
        }

        return true
      }

      // Executed if and only if ubliqueStyle is being passed
      if (ubliqueStyle) {
        // It removes the not-supported classes and map them to ublique-${className}
        classes = ubliqueStyle
          .split(' ')
          .filter(filterClassName)
          .map((name) => `ublique-${name}`)

        // The ublique-fixed prop is valid if and only if one single value is provided
        if (ubliqueFixed) {
          if (classes.length === 1) {
            classes.push('ublique-fixed')
          } else {
            console.warn(
              'The fixed prop is valid only when a single value is provided, hence ublique-fixed will be ignored.'
            )
          }
        }

        // Merge between the componentClassName and the new classes
        classes = cn(componentClassName, classes.join(' '))
      }

      // The empty prop is invalid
      if (ubliqueStyle === '') {
        console.warn(
          'If you want to use the ublique responsiveness, please provide some values'
        )
      }

      return classes
    }, [ubliqueStyle, ubliqueFixed])
    return (
      <WrappedComponent
        {...otherProps}
        ref={ref}
        className={cn(props.className, newClassname)}
      />
    )
  })
}

export default withUbliqueStyle
